import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";
import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import { orderManager } from "../data/managers/OrderManager";
import { useUserData } from "../data/providers/UserDataProvider";
import { useExportSales } from "./hooks/useExportSales";
import { useOrdersByDate } from "./hooks/useOrdersByDate";

export default function HomePage() {
  const userData = useUserData()!;
  const firstName = userData?.data.fullName?.split(" ")[0] ?? "Usuario";

  const fetchOrders = (from: string, to: string) =>
    orderManager.getAllOrdersByDate({ from, to });

  const { from, to, setFrom, setTo, orders, loading, search } =
    useOrdersByDate(fetchOrders);

  const { exportExcel } = useExportSales(orders);

  return (
    <Stack spacing={3} m={3}>
      {/* HEADER */}
      <Box
        sx={{
          p: 3,
          borderRadius: 4,
          bgcolor: "primary.main",
          color: "white",
        }}
      >
        <Typography variant="h5" fontWeight={800}>
          ¡Bienvenido, {firstName}! 👋
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.9 }}>
          Consulta y exporta tus ventas por fecha y hora
        </Typography>
      </Box>

      {/* CONTROLES */}
      {userData?.data.role.includes("ADMIN") && (
        <Box
          sx={{
            p: 2,
            borderRadius: 3,
            border: "1px solid",
            borderColor: "divider",
          }}
        >
          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={2}
            alignItems="center"
          >
            <TextField
              type="datetime-local"
              size="small"
              label="Desde"
              InputLabelProps={{ shrink: true }}
              value={from}
              onChange={(e) => setFrom(e.target.value)}
            />

            <TextField
              type="datetime-local"
              size="small"
              label="Hasta"
              InputLabelProps={{ shrink: true }}
              value={to}
              onChange={(e) => setTo(e.target.value)}
            />

            <Button
              variant="outlined"
              startIcon={<SearchIcon />}
              onClick={search}
              disabled={loading}
            >
              Buscar ventas
            </Button>

            <Button
              variant="contained"
              startIcon={<DownloadIcon />}
              onClick={exportExcel}
              disabled={orders.length === 0}
            >
              Exportar Excel
            </Button>
          </Stack>

          {orders.length > 0 && (
            <Typography mt={2} variant="body2" color="text.secondary">
              {orders.length} órdenes encontradas
            </Typography>
          )}
        </Box>
      )}
    </Stack>
  );
}
